import { render, staticRenderFns } from "./IconPullQuote.vue?vue&type=template&id=c16a3d4e&scoped=true&"
import script from "./IconPullQuote.vue?vue&type=script&lang=js&"
export * from "./IconPullQuote.vue?vue&type=script&lang=js&"
import style0 from "./IconPullQuote.vue?vue&type=style&index=0&id=c16a3d4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c16a3d4e",
  null
  
)

export default component.exports